// extracted by mini-css-extract-plugin
module.exports = {"customTooltip":"barChart_customTooltip__3nxEn"};